import LabPage from "../components/layout/LabPage";
import { Presentation, Sparkles, Image as ImageIcon, BarChart, Wand2, Crosshair, ListOrdered, Camera } from "lucide-react";

export default function SlideLab() {
  return (
    <LabPage
      testId="slide-lab-page"
      kicker="SlideLab"
      title="Decks that close, train, and convert"
      description="Webinars, pitch decks, training, sales, and investor decks — generated, restyled, and exported with talking points and presenter notes."
      heroImage="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=900&q=80"
      heroTone="mixed"
      actions={[{ label: "Generate Deck", icon: Wand2, to: "/create" }]}
      quickActions={[
        { label: "AI Outline", icon: ListOrdered },
        { label: "One-click Restyle", icon: Sparkles },
        { label: "Screenshot Annotate", icon: Camera },
        { label: "Add Funnel Diagram", icon: Crosshair },
      ]}
      features={[
        { icon: Presentation, title: "Slide-by-slide AI", description: "Generate full decks with title, body, talking points, and notes." },
        { icon: ImageIcon, title: "Image Generation", description: "Hero shots, backgrounds, mockups via Nano Banana / image provider." },
        { icon: BarChart, title: "Charts & Diagrams", description: "Funnels, proof stacks, before/after blocks." },
        { icon: Camera, title: "Screenshot Annotator", description: "Upload a page → AI adds callouts, arrows, and CTA labels." },
        { icon: Crosshair, title: "Objection Handling", description: "AI generates objection slides, refute, and proof." },
        { icon: Sparkles, title: "Premium Restyle", description: "One-click upgrade to Dark Authority or Blackbook Keynote." },
      ]}
      styles={[
        { tag: "Style", title: "Dark Authority Webinar", description: "Cinematic dark, aqua glow, big claims." },
        { tag: "Style", title: "Blackbook Keynote", description: "Editorial, serif, large numbers, quote-led." },
        { tag: "Style", title: "Neon Green Blueprint", description: "Lime accents, blueprint grid, technical." },
        { tag: "Style", title: "Premium SaaS Pitch", description: "Investor narrative, proof stack, traction." },
      ]}
      sampleAssets={[
        { title: "Q1 Investor Deck", thumb: "https://images.unsplash.com/photo-1542744095-291d1f67b221?w=500&q=80", meta: "32 slides" },
        { title: "Authority Webinar", thumb: "https://images.unsplash.com/photo-1573164713988-8665fc963095?w=500&q=80", meta: "48 slides" },
        { title: "Coaching Sales Deck", thumb: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=500&q=80", meta: "24 slides" },
        { title: "Training Module 4", thumb: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=500&q=80", meta: "18 slides" },
      ]}
    />
  );
}
